module.exports = __webpack_public_path__ + "static/media/ic_reset_gray.4b6809bb.svg";